import { ChatClient } from "@azure/communication-chat";
import { AzureCommunicationTokenCredential } from "@azure/communication-common";
import { extractInitials } from '../utils/GenericFunction'
import axios from "axios";
import { useLiveStreamAppContext } from "../ContextStore/Store";
import ChangeButton from "./ChangeButton";
import EndLiveStream from "./EndLiveStream";

const ChatInitialize = () => {
  const {
    token,
    chatClientRef,
    threadId,
    role,
    chatThreadClientRef,
    communicationUserId,
    setRecordedFilePath,
    hostCommunicationUserId,
    photoHostUrl,
    setRecordingNotification,
    callN,
    setToggleStates,
    setIsChatDisabled,
    userNameHost,
    __userId,
    __merchantId,
    appInsightTrack,
    setAttendees,
    setIsInstructorMode,
    setDisableCam,
    setIsMic,
    setSessionStartTimeUTC,
    setIsRecordingStarted,
    setDisableMic,
    __appConfirmUniqueID,
    headers,
    screenName,
    setErrorMessage,
    attendeesLookup,
    toggleStates,
    isInstructorModeRef,
    setstrExtendedEndTimeUTC,
    eventType,
    apiUrlPost,
    setMessages,
    setChatColor,
  } = useLiveStreamAppContext();

  const { endCall } = EndLiveStream();
  const { changeButtonStatus } = ChangeButton();
  let flag = true;

  //Function to Initialize Messages in Chat on Class Seession screen
  const loadInitialMessages = async () => {
    try {
      const chatHistoryResponse = await axios.post(
        `${apiUrlPost}chathistory`,
        {
          appConfirmUniqueId: __appConfirmUniqueID,
          currentpageindex: 1,
          pagesize: 50,
        },
        { headers }
      );

      if (chatHistoryResponse?.data?.data?.chatHistory?.length > 0) {
        const initialMessages =
          chatHistoryResponse?.data?.data?.chatHistory?.map((message) => {
            const matchingAttendee = attendeesLookup[message.communicationUserId]
            let hostPhoto;
            if (message?.communicationUserId === hostCommunicationUserId) {
              hostPhoto = photoHostUrl;
            }
            const senderDisplayName = matchingAttendee
              ? matchingAttendee.screenName !== ""
                ? matchingAttendee.screenName
                : `${matchingAttendee.firstName} ${matchingAttendee.lastName}`
              : hostCommunicationUserId === message.communicationUserId
                ? screenName
                : "" || "Unknown";
            return {
              id: message.messageId,
              content: { message: message.message },
              senderDisplayName: senderDisplayName,
              isDisableChat: message.isDisableChat,
              isDeleted: message.isDeleted,
              isEdited: message.isEdited,
              initials: extractInitials(senderDisplayName),
              photo:
                hostPhoto?.length > 0 ? hostPhoto : matchingAttendee?.photo,
              communicationUserId: message.communicationUserId,
              createdOn: new Date(message.strTime),
              editedOn: message.isEdited ? new Date() : null,
              type: "text",
            };
          });
        setMessages(initialMessages);
      } else {
        console.warn("No valid chat history data found");
      }
    } catch (error) {
      console.error("Error loading chat history:", error);
      setErrorMessage(error.message);
      appInsightTrack(__merchantId, __userId, "API Error chathistory", "", error);
    }
  };

  async function ChatDisabledStatus(newMessage, data) {
    setMessages((prevMessages) => [...prevMessages, newMessage]);
    if (role === "Attendee") {
      return;
    }
    const timestamp = new Date().toISOString();
    const payload = {
      appConfirmUniqueId: __appConfirmUniqueID,
      message: newMessage.content.message,
      messageId: newMessage.id,
      communicationUserId: communicationUserId.communicationUserId,
      IsDisableChat: data,
      time: timestamp,
      strTime: timestamp,
    };

    await axios.post(
      `${apiUrlPost}managechathistory`,
      payload,
      { headers }
    );
    // Dispose or reset sensitive data after use
    payload.appConfirmUniqueId = null;
    payload.message = null;
    payload.messageId = null;
    payload.communicationUserId = null;
  }

  async function ChatInitialization() {
    if (threadId && token) {
      try {
        const chatClient = new ChatClient(
          process.env.REACT_APP_ACS_END_POINT_URL,
          new AzureCommunicationTokenCredential(token)
        );
        chatClientRef.current = chatClient;
        const chatThreadClient = await chatClient.getChatThreadClient(threadId);
        chatThreadClientRef.current = chatThreadClient;
        await chatClient.startRealtimeNotifications();
        await loadInitialMessages();

        chatClient.on("chatMessageReceived", (e) => {

          var targetUserId;
          var customType = "";
          if (Object.keys(e.metadata).length > 0) {
            targetUserId = e.metadata ? e.metadata.targetUserId : null;
            customType = e.metadata?.customType;
          }

          if (e.message.includes("recording file you requested")) {
            //We are pleased to inform you that the recording file you requested is now available. You can download it using the link :https://devlivestreammediafiles.blob.core.windows.net/stream-container/20241113/6bc76e9c-02ea-4bd1-8733-11a8c6cd9f81/NlNzAifQ-f94c4f0e-9bb1-4896-95e3-988d582e3e70/0-video.mp4
            // Regular expression to match the URL
            const filePathURL = e.message.match(/https?:\/\/[^\s]+/);
            if (filePathURL) {
              setRecordedFilePath(filePathURL[0]);
            }
            return;
          }
          const actions = {
            NORMAL_CHAT: () => {
              const matchingAttendee = attendeesLookup[e.sender.communicationUserId]
              let hostPhoto;
              if (e?.sender?.communicationUserId === hostCommunicationUserId) {
                hostPhoto = photoHostUrl
              }
              setMessages((prevMessages) => [
                ...prevMessages,
                {
                  communicationUserId: e.sender.communicationUserId,
                  content: { message: e.message },
                  createdOn: e.createdOn,
                  editedOn: null,
                  id: e.id,
                  photo: hostPhoto?.length > 0 ? hostPhoto : matchingAttendee?.photo,
                  senderDisplayName: e.senderDisplayName,
                  initials: extractInitials(e.senderDisplayName),
                  type: "text",
                },
              ]);
              if (e.sender.communicationUserId !== communicationUserId.communicationUserId) {
                setChatColor(true)
              }
            },
            MEETING_END: () => {
              if (role === "Attendee") {
                try {
                  endCall();
                } catch (e) {
                  appInsightTrack(__merchantId, __userId, "Error in Meeting end", "", e);
                }
              }
            },
            EXTEND_TIME: () => {
              setstrExtendedEndTimeUTC(e.metadata?.extendedDate);
            },
            DISABLE_START_RECORDING_FOR_ALL: () => {
              setRecordingNotification("STOP");
            },
            ENABLE_START_RECORDING_FOR_ALL: () => {
              setRecordingNotification("START");
            },
            DISABLE_VIDEO_FOR_ALL: () => {
              if (role === "Attendee") {
                if (callN.current.isLocalVideoStarted === true) {
                  const localVideoStream = callN.current.localVideoStreams.find(
                    (stream) => {
                      return stream.mediaStreamType === "Video";
                    }
                  );
                  callN.current.stopVideo(localVideoStream);
                }
                changeButtonStatus("camIconDiv", "camIcon", customType, "all");
                setToggleStates((prevStates) => ({
                  ...prevStates,
                  mirrorMyVideo: false,
                  blurBackground: false,
                }));
                let blurBackground = document.getElementById("blurBackgrounddiv");
                !blurBackground?.classList.contains("divDisabled") && blurBackground?.classList.add("divDisabled");
                let mirrorMyVideo = document.getElementById("mirrorMyVideodiv");
                !mirrorMyVideo?.classList.contains("divDisabled") && mirrorMyVideo?.classList.add("divDisabled");
              }
            },
            ENABLE_VIDEO_FOR_ALL: () => {
              if (role === "Attendee") {
                changeButtonStatus("camIconDiv", "camIcon", customType, "all");
              }
            },
            DISABLE_MIC_FOR_ALL: () => {
              if (role === "Attendee") {
                changeButtonStatus("micIconDiv", "micIcon", customType, "all");
                setToggleStates((prevStates) => ({
                  ...prevStates,
                  EnableMic: false,
                  removeBackgroundNoise: false,
                  shareDeviceAudio: false,
                }));
                let removeBackgroundNoise = document.getElementById("removeBackgroundNoisediv");
                !removeBackgroundNoise?.classList.contains("divDisabled") && removeBackgroundNoise?.classList.add("divDisabled");
                let shareDeviceAudio = document.getElementById("shareDeviceAudiodiv");
                !shareDeviceAudio?.classList.contains("divDisabled") && shareDeviceAudio?.classList.add("divDisabled");
              }
            },
            ENABLE_MIC_FOR_ALL: () => {
              if (role === "Attendee") {
                changeButtonStatus("micIconDiv", "micIcon", customType, "all");
              }
              setToggleStates((prevStates) => ({
                ...prevStates,
                EnableMic: true,
              }));
              let shareDeviceAudio = document.getElementById("shareDeviceAudiodiv");
              shareDeviceAudio?.classList.contains("divDisabled") && shareDeviceAudio?.classList.remove("divDisabled");
            },
            DISABLE_CHAT_FOR_ALL: () => {
              setToggleStates((prevStates) => ({
                ...prevStates,
                EnableChat: false,
              }));
              let disableData = {
                communicationUserId: hostCommunicationUserId,
                content: { message: "Chat is Disabled by Host" },
                createdOn: e.createdOn,
                editedOn: null,
                id: e.id,
                isDisableChat: true,
                senderDisplayName: e.senderDisplayName,
                initials: extractInitials(e.senderDisplayName),
                type: "text",
              };
              ChatDisabledStatus(disableData, true);
              if (role === "Attendee") {
                setIsChatDisabled(true);
              }
            },
            ENABLE_CHAT_FOR_ALL: () => {
              setToggleStates((prevStates) => ({
                ...prevStates,
                EnableChat: true,
              }));
              let enableData = {
                communicationUserId: hostCommunicationUserId,
                content: { message: "Chat is Enabled by Host" },
                createdOn: e.createdOn,
                editedOn: null,
                isDisableChat: false,
                id: e.id,
                senderDisplayName: userNameHost,
                initials: extractInitials(userNameHost),
                type: "text",
              };
              ChatDisabledStatus(enableData, false);
              if (role === "Attendee") {
                setIsChatDisabled(false);
              }
            },
            DISABLE_SCREEN_SHARE_FOR_ALL: () => {
              if (role === "Attendee") {
                setToggleStates((prevStates) => ({
                  ...prevStates,
                  EnableScreenShare: false,
                }));
                changeButtonStatus("screenShareIcon", "screenShareIcon", customType);
              }
            },
            ENABLE_SCREEN_SHARE_FOR_ALL: () => {
              if (role === "Attendee") {
                setToggleStates((prevStates) => ({
                  ...prevStates,
                  EnableScreenShare: true,
                }));
                changeButtonStatus("screenShareIcon", "screenShareIcon", customType);
              }
            },
            DISABLE_VIDEO_FOR_INDIVIDUAL: () => {
              if (
                role === "Attendee" &&
                targetUserId === communicationUserId.communicationUserId
              ) {
                if (callN.current.isLocalVideoStarted === true) {
                  const localVideoStream = callN.current.localVideoStreams.find(
                    (stream) => {
                      return stream.mediaStreamType === "Video";
                    }
                  );
                  callN.current.stopVideo(localVideoStream);
                  const element = document.getElementById("camIcon");
                  if (!element.classList.contains("va-video-slash")) {
                    element.classList.add("va-video-slash");
                  }
                }
                setToggleStates((prevStates) => ({
                  ...prevStates,
                  mirrorMyVideo: false,
                  blurBackground: false,
                }));
                let blurBackground = document.getElementById("blurBackgrounddiv");
                !blurBackground?.classList.contains("divDisabled") && blurBackground?.classList.add("divDisabled");
                let mirrorMyVideo = document.getElementById("mirrorMyVideodiv");
                !mirrorMyVideo?.classList.contains("divDisabled") && mirrorMyVideo?.classList.add("divDisabled");
              }
            },
            ENABLE_VIDEO_FOR_INDIVIDUAL: () => {
              if (
                role === "Attendee" &&
                targetUserId === communicationUserId.communicationUserId
              ) {
                if (callN.current.isLocalVideoStarted.current === false) {
                  const conElementId2 = document.getElementById("camIcon");
                  conElementId2.click();
                }
                setDisableCam(false);
              }
            },
            DISABLE_MIC_FOR_INDIVIDUAL: () => {
              if (
                role === "Attendee" &&
                targetUserId === communicationUserId.communicationUserId
              ) {
                setIsMic(false);
                setToggleStates((prev) => ({
                  ...prev,
                  shareDeviceAudio: false
                }))
                if (eventType === 1) {
                  let shareDeviceAudio = document.getElementById("shareDeviceAudiodiv");
                  !shareDeviceAudio?.classList.contains("divDisabled") && shareDeviceAudio?.classList.add("divDisabled");
                }
              }
            },
            DISABLE_CHAT_FOR_INDIVIDUAL: () => {
              if (
                role === "Attendee" &&
                targetUserId === communicationUserId.communicationUserId
              ) {
                setIsChatDisabled(true);
              }
            },
            ENABLE_CHAT_FOR_INDIVIDUAL: () => {
              if (
                role === "Attendee" &&
                targetUserId === communicationUserId.communicationUserId
              ) {
                setIsChatDisabled(false);
              }
            },
            DISABLE_SCREEN_SHARE_FOR_INDIVIDUAL: () => {
              if (
                role === "Attendee" &&
                targetUserId === communicationUserId.communicationUserId
              ) {
                setToggleStates((prevStates) => ({
                  ...prevStates,
                  EnableScreenShare: false,
                }));
                changeButtonStatus(
                  "screenShareIcon",
                  "screenShareIcon",
                  customType,
                  ""
                );
              }
            },
            ENABLE_SCREEN_SHARE_FOR_INDIVIDUAL: () => {
              setToggleStates((prevStates) => ({
                ...prevStates,
                EnableScreenShare: true,
              }));
              if (
                role === "Attendee" &&
                targetUserId === communicationUserId.communicationUserId
              ) {
                changeButtonStatus(
                  "screenShareIcon",
                  "screenShareIcon",
                  customType,
                  ""
                );
              }
            },
            HOST_SETTING: () => {
              if (role === "Attendee" && (targetUserId === communicationUserId.communicationUserId || targetUserId === "" || targetUserId === undefined)) {
                var strSessionStartTime = "";
                var isInstructorOnlyMode = "";
                var isDisableMichrophoneforAllAttendees = "";
                var isDisableVideoforAllAttendes = "";
                var isDisableChatforAllAttendes = "";
                var isStartRecording = "";
                var isDisableScreenShareforAllAttendees = "";
                strSessionStartTime = e.metadata?.strSessionStartTime;
                isInstructorOnlyMode = eventType === 1 ? "false" : e.metadata?.isInstructorOnlyMode;
                isDisableMichrophoneforAllAttendees = e.metadata?.isDisableMichrophoneforAllAttendees;
                isDisableVideoforAllAttendes = e.metadata?.isDisableVideoforAllAttendes;
                isDisableChatforAllAttendes = e.metadata?.isDisableChatforAllAttendes;
                isStartRecording = e.metadata?.isStartRecording;
                isDisableScreenShareforAllAttendees = e.metadata?.isDisableScreenShareforAllAttendees;

                setSessionStartTimeUTC(strSessionStartTime);
                setIsInstructorMode(isInstructorOnlyMode === "true" ? true : false);
                isInstructorModeRef.current = isInstructorOnlyMode === "true" ? true : false;
                if (isStartRecording === "true") {
                  if (!toggleStates["StartRecording"] || flag) {
                    setIsRecordingStarted(isStartRecording === "true" ? true : false);
                    setRecordingNotification(isStartRecording === "true" ? "START" : false);
                    flag = false;
                  }
                } else {
                  setIsRecordingStarted(false);
                  setRecordingNotification(false);
                }
                setToggleStates((prevStates) => ({
                  ...prevStates,
                  StartRecording: isStartRecording === "true" ? true : false,
                }));
                if (isDisableMichrophoneforAllAttendees === "true") {
                  changeButtonStatus("micIconDiv", "micIcon", "DISABLE", "all");
                  setDisableMic(true);
                  if (!callN.current.isMuted) callN.current.mute();
                  setToggleStates((prevStates) => ({
                    ...prevStates,
                    EnableMic: false,
                    removeBackgroundNoise: false,
                    shareDeviceAudio: false,
                  }));
                  let removeBackgroundNoise = document.getElementById("removeBackgroundNoisediv");
                  !removeBackgroundNoise?.classList.contains("divDisabled") && removeBackgroundNoise?.classList.add("divDisabled");
                  let shareDeviceAudio = document.getElementById("shareDeviceAudiodiv");
                  !shareDeviceAudio?.classList.contains("divDisabled") && shareDeviceAudio?.classList.add("divDisabled");
                } else {
                  changeButtonStatus("micIconDiv", "micIcon", "ENABLE", "all");
                  setDisableMic(false);
                  let shareDeviceAudio = document.getElementById("shareDeviceAudiodiv");
                  shareDeviceAudio?.classList.contains("divDisabled") && shareDeviceAudio?.classList.remove("divDisabled");
                }

                if (isDisableVideoforAllAttendes === "true") {
                  if (callN.current.isLocalVideoStarted === true) {
                    const localVideoStream = callN.current.localVideoStreams.find((stream) => {
                      return stream.mediaStreamType === "Video";
                    });
                    callN.current.stopVideo(localVideoStream);
                  }
                  setDisableCam(true);
                  changeButtonStatus("camIconDiv", "camIcon", "DISABLE", "all");
                  setToggleStates((prevStates) => ({
                    ...prevStates,
                    mirrorMyVideo: false,
                    blurBackground: false,
                  }));
                  let blurBackground = document.getElementById("blurBackgrounddiv");
                  !blurBackground?.classList.contains("divDisabled") && blurBackground?.classList.add("divDisabled");
                  let mirrorMyVideo = document.getElementById("mirrorMyVideodiv");
                  !mirrorMyVideo?.classList.contains("divDisabled") && mirrorMyVideo?.classList.add("divDisabled");
                } else {
                  setDisableCam(false);
                  changeButtonStatus("camIconDiv", "camIcon", "ENABLE", "all");
                }
                setIsChatDisabled(
                  isDisableChatforAllAttendes === "true" ? true : false
                );
                if (isDisableChatforAllAttendes === "true") {
                  setToggleStates((prevStates) => ({
                    ...prevStates,
                    EnableChat: false,
                  }));
                } else {
                  setToggleStates((prevStates) => ({
                    ...prevStates,
                    EnableChat: true,
                  }));
                }

                if (isDisableScreenShareforAllAttendees === "true") {
                  setAttendees((prevAttendees) =>
                    prevAttendees.map((attendee) => ({
                      ...attendee,
                      isScreenShareDisabled: true,
                    }))
                  );
                  changeButtonStatus(
                    "screenShareIcon",
                    "screenShareIcon",
                    "DISABLE",
                    "all"
                  );
                } else {
                  setAttendees((prevAttendees) =>
                    prevAttendees.map((attendee) => ({
                      ...attendee,
                      isScreenShareDisabled: false,
                    }))
                  );
                  changeButtonStatus(
                    "screenShareIcon",
                    "screenShareIcon",
                    "ENABLE",
                    "all"
                  );
                }

                setIsInstructorMode(
                  isInstructorOnlyMode === "true" ? true : false
                );
                return;
              }
            },
            DELETE_CHAT: () => {
              setMessages((prevMessages) =>
                prevMessages.map((msg) =>
                  msg.id === e.metadata.messageId
                    ? {
                      ...msg,
                      isDeleted: true
                    }
                    : msg
                )
              );
            },
            UNDO_CHAT: () => {
              setMessages((prevMessages) =>
                prevMessages.map((msg) =>
                  msg.id === e.metadata.messageId
                    ? {
                      ...msg,
                      isDeleted: false,
                    }
                    : msg
                )
              );
            }
          }
          if (actions[customType]) {
            let obj = [
              "NORMAL_CHAT",
              "DISABLE_CHAT_FOR_ALL",
              "ENABLE_CHAT_FOR_ALL",
              "DELETE_CHAT",
              "UNDO_CHAT",
            ];

            if (role === "Presenter" && obj.includes(customType)) {
              actions[customType]();
            } else if (role === "Attendee") {
              actions[customType]();
            }
          } else {
            console.warn(`Unhandled customType: ${customType}`);
          }
        });

        chatClient.on("chatMessageEdited", (e) => {
          setMessages((prevMessages) =>
            prevMessages.map((msg) =>
              msg.id === e.id
                ? {
                  ...msg,
                  content: { message: e.message },
                  isEdited: true,
                  editedOn: e.editedOn,
                }
                : msg
            )
          );
        })

      } catch (error) {
        console.error("Error initializing chat:", error);
        appInsightTrack(__merchantId, __userId, "Error initializing chat", "", error);
      }
    }
  }

  return { ChatInitialization }
}

export default ChatInitialize